import React, {useEffect, useMemo, useReducer, useState} from "react";
import connection from "../../connection";
import general from "../../general";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CardBody from "../../components/Card/CardBody";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash, faPlus, faSearchPlus, faTrashAlt} from "@fortawesome/free-solid-svg-icons";

import PreencherFeedback from "views/Pages/PreencherFeedback.jsx";

import formacoesStyle from "assets/jss/material-dashboard-pro-react/views/formacoesStyle.jsx";
import SweetAlert from "components/SweetAlertWrapper";
import ReactTable from "components/ReactTableWrapper";
import StateCircle from "../../components/StateCircle";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import PaginaFormacao from "./PaginaFormacao";
import useDebounce from "../../functions/useDebounce";
import CaixaFiltrosAcontecimento, {ProviderFiltrosAcontecimento, WidgetsFiltrosAcontecimento} from "../../components/FiltrosAcontecimento/FiltrosAcontecimento";

const FormacoesUtilizador = (props) => {
  const [modal, setModal] = useState(null);

  const CardFormador = useMemo(() => {
    let C = () => {
      if (!general.userHasType("formador", "formador_aux", "secretario_regional")) return null;

      const [state, setState] = useReducer(
        (state, newState) => ({...state, ...newState}),
        {
          filter: {},
          search: "",
          data: {formacoes_formador: []},
          page: 0,
          pageSize: 20
        });
      const debouncedFilter = useDebounce(state.search, 500);
      const [filterActive, setFilterActive] = useState(false);

      const apagarFormacao = (formacao) => {
        setModal(<SweetAlert
          warning
          title="Apagar Formação"
          onConfirm={async () => {
            await connection.post("formacao/apagar", {id: formacao.id});
            general.success("Formação apagada com sucesso.", "Sucesso!");
            setModal(null)
            reloadFormacoes();
          }}
          onCancel={() => setModal(null)}
          confirmBtnCssClass={
            classes.button + " " + classes.danger
          }
          cancelBtnCssClass={
            classes.button
          }
          confirmBtnText="Apagar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Atenção! Ao apagar este módulo (#{general.pad(formacao.id, 5)} - {formacao.designacao}) serão apagadas todas as informaões do mesmo.
        </SweetAlert>)
      }

      const reloadFormacoes = () => {
        connection.get("formacao/listagem_formador", {
          filtro: state.search,
          filtragem: state.filter,
          numero_resultados: state.pageSize,
          pagina: state.page
        }).then(({formacoes, paginacao}) => {
          setState({
            data: {
              paginacao,
              formacoes_formador: formacoes
            }
          })
        });
      }

      useEffect(() => {
        reloadFormacoes();
      }, [state.page, state.filter, debouncedFilter]);

      const pesquisarFormacoesFormador = async (filtro, pesquisa) => {
        let filtragem = {...filtro}

        for (let key in filtragem)
          if (!filtragem[key] || filtragem[key].length === 0) delete filtragem[key];

        setState({
          page: 0,
          filter: filtragem,
          search: pesquisa
        });
      }

      return <ProviderFiltrosAcontecimento acontecimento={'formacao'}
                                           atualizar={pesquisarFormacoesFormador}
                                           filterActive={setFilterActive}
                                           lista_filtros={['regiao', 'nucleo', 'agrupamento', 'estado_acontecimento', 'modulo', 'data_desde', 'data_ate', 'enriquecimento', 'formacao_continua']}
      ><Card>
        <CardHeader color="primary">
          <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <h4 style={{flex: 1}}>Gerir Módulos</h4>
            <WidgetsFiltrosAcontecimento/>
            {general.userHasPermission("formacao.criar") && <Button
              className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
              onClick={() => {
                adicionarFormacao((id_formacao) => {
                  window.App.hist.push("/formacao/" + id_formacao);
                });
              }}
              color="success"
            >
              <FontAwesomeIcon icon={faPlus}/> Criar Módulo
            </Button>}
          </div>
          {!filterActive && <p>Consulte abaixo os módulos que está a dirigir.</p>}
        </CardHeader>
        <CaixaFiltrosAcontecimento/>
        <ReactTable
          data={state.data?.formacoes_formador.map((formacao) => {
            formacao.actions = (<React.Fragment>
              <Button
                justIcon
                round
                simple
                onClick={() => {
                  window.App.hist.push("/formacao/" + formacao.id)
                }}
                style={{margin: 0}}
                color="info"
                className="edit"
              >
                <FontAwesomeIcon icon={faSearchPlus}/>
              </Button>
              {formacao.pode_apagar && <Button
                justIcon
                round
                simple
                style={{margin: 0}}
                onClick={() => {
                  apagarFormacao(formacao)
                }}
                color="danger"
                className="edit"
              >
                <FontAwesomeIcon icon={faTrashAlt}/>
              </Button>}
            </React.Fragment>);
            return formacao;
          })}
          minRows={1}
          columns={[
            {
              Header: "Formação",
              Cell: (row) => {
                return <span><StateCircle state={row.original.estado}/> #{general.pad(row.original.id, 5)} - {row.original.designacao}</span>
              }
            },
            {
              Header: "Curso",
              accessor: "curso",
              Cell: (row) => {
                return row.original.curso ? <span><StateCircle state={row.original.curso.estado}/> {row.original.curso.descricao}</span> : "Sem curso"
              }
            },
            {
              Header: "Data",
              accessor: "data_inicio",
              Cell: general.Renderers.dateRenderer
            },
            {
              Header: "Local",
              accessor: "regiao",
              width: 250,
              Cell: (row) => row.original.nucleo ? row.original.nucleo + ' / ' + row.original.regiao : row.original.regiao
            },
            {
              Header: "Inscritos",
              accessor: "inscritos",
              width: 140
            },
            {
              Header: "Participantes",
              accessor: "participantes",
              width: 150
            },
            {
              Header: "Presentes",
              accessor: "presentes",
              width: 120
            },
            {
              Header: "",
              accessor: "actions",
              width: 115,
              sortable: false
            }
          ]}
          defaultPageSize={state.pageSize}
          showPaginationBottom={true}
          sortable={false}
          className="-striped -highlight"
          pages={state.data?.paginacao?.paginas}
          manual
          onFetchData={(state) => {
            setState({page: state.page, pageSize: state.pageSize});
          }}
        />
      </Card></ProviderFiltrosAcontecimento>
    };
    return <C/>
  }, []);

  const CardRegiao = useMemo(() => {
        let C = () => {
          if (!general.userHasType("secretario_regional", "admin", "chefe_nacional", "chefe_regional"))
            return null;

          const [state, setState] = useReducer(
            (state, newState) => ({...state, ...newState}),
            {
              filter: {},
              search: "",
              data: {formacoes_regiao: []},
              page: 0,
              pageSize: 12
            });

          const debouncedFilter = useDebounce(state.search, 500);

          const apagarFormacao = (formacao) => {
            setModal(<SweetAlert
              warning
              title="Apagar Formação"
              onConfirm={async () => {
                await connection.post("formacao/apagar", {id: formacao.id});
                general.success("Formação apagada com sucesso.", "Sucesso!");
                setModal(null)
                reloadFormacoes();
              }}
              onCancel={() => setModal(null)}
              confirmBtnCssClass={
                classes.button + " " + classes.danger
              }
              cancelBtnCssClass={
                classes.button
              }
              confirmBtnText="Apagar"
              cancelBtnText="Cancelar"
              showCancel
            >
              Atenção! Ao apagar este módulo (#{general.pad(formacao.id, 5)} - {formacao.designacao}) serão apagadas todas as informaões do mesmo.
            </SweetAlert>)
          }

          const reloadFormacoes = () => {
            connection.get("formacao/listagem_gestao", {
              filtro: state.search,
              filtragem: state.filter,
              numero_resultados: state.pageSize,
              pagina: state.page
            }).then(({formacoes, paginacao}) => {
              setState({data: {paginacao, formacoes_regiao: formacoes}});
            })
          }

          useEffect(() => {
            reloadFormacoes();
          }, [state.page, state.filter, debouncedFilter]);

          const pesquisarFormacoesGestao = async (filtro, pesquisa) => {
            let filtragem = {...filtro}

            for (let key in filtragem)
              if (!filtragem[key] || filtragem[key].length === 0) delete filtragem[key];

            setState({
              page: 0,
              filter: filtragem,
              search: pesquisa
            });
          }

          return <ProviderFiltrosAcontecimento acontecimento={'formacao'}
                                               atualizar={pesquisarFormacoesGestao}
                                               lista_filtros={['regiao', 'nucleo', 'agrupamento', 'estado_acontecimento', 'modulo', 'diretor', 'data_desde', 'data_ate', 'enriquecimento', 'formacao_continua']}><Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", zIndex: 0}}>
                <h4 style={{flex: 1}}>Módulos {general.userHasType("secretario_regional") ? "da Região" : ""}</h4>
                <WidgetsFiltrosAcontecimento/>
              </div>
            </CardHeader>
            <CaixaFiltrosAcontecimento/>
            <ReactTable
              data={state.data.formacoes_regiao.map((formacao) => {
                formacao.actions = (<React.Fragment>
                  <Button
                    justIcon
                    round
                    simple
                    onClick={() => {
                      window.App.hist.push("/formacao/" + formacao.id)
                    }}
                    style={{margin: 0}}
                    color="info"
                    className="edit"
                  >
                    <FontAwesomeIcon icon={faSearchPlus}/>
                  </Button>
                  {formacao.pode_apagar && <Button
                    justIcon
                    round
                    simple
                    style={{margin: 0}}
                    onClick={() => {
                      apagarFormacao(formacao);
                    }}
                    color="danger"
                    className="edit"
                  >
                    <FontAwesomeIcon icon={faTrashAlt}/>
                  </Button>}
                </React.Fragment>);
                return formacao;
              })}
              minRows={1}
              columns={[
                {
                  Header: "Formação",
                  Cell: (row) => {
                    return <span><StateCircle state={row.original.estado}/> #{general.pad(row.original.id, 5)} - {row.original.designacao}</span>
                  }
                },
                {
                  Header: "Curso",
                  accessor: "curso",
                  Cell: (row) => {
                    return row.original.curso ? <span><StateCircle state={row.original.curso.estado}/> {row.original.curso.descricao}</span> : "Sem curso"
                  }
                },
                {
                  Header: "Data",
                  accessor: "data_inicio",
                  Cell: general.Renderers.dateRenderer
                },
                {
                  Header: "Local",
                  accessor: "regiao",
                  width: 250,
                  Cell: (row) => row.original.nucleo ? row.original.nucleo + ' / ' + row.original.regiao : row.original.regiao
                },
                {
                  Header: "Inscritos",
                  accessor: "inscritos",
                  width: 140
                },
                {
                  Header: "Participantes",
                  accessor: "participantes",
                  width: 150
                },
                {
                  Header: "Presentes",
                  accessor: "presentes",
                  width: 140
                },
                {
                  Header: "",
                  accessor: "actions",
                  width: 115,
                  sortable: false
                }
              ]}
              defaultPageSize={state.pageSize}
              showPaginationBottom={true}
              sortable={false}
              className="-striped -highlight"
              pages={state.data?.paginacao?.paginas}
              manual
              onFetchData={(state) => {
                setState({page: state.page, pageSize: state.pageSize});
              }}
            />
          </Card></ProviderFiltrosAcontecimento>
        };
        return <C/>
      }, []
    )
  ;

  const CardDisponiveis = useMemo(() => {
    let C = () => {
      if (!general.userHasType("formando") && !general.userHasType("dirigente")) return null;

      const [state, setState] = useReducer(
        (state, newState) => ({...state, ...newState}),
        {
          filter: {},
          search: "",
          mostrar_outras_regioes: false,
          data: {formacoes_disponiveis: []},
          page: 0,
          pageSize: 8
        });
      const debouncedFilter = useDebounce(state.search, 500);
      const [filterActive, setFilterActive] = useState(false);

      const reloadFormacoes = () => {
        connection.get("formacao/listagem_disponiveis", {
          filtro: state.search,
          filtragem: state.filter,
          regiao: state.mostrar_outras_regioes ? null : window.App.state.user.regiao,
          numero_resultados: state.pageSize,
          pagina: state.page
        }).then(data => setState({data}));
      }

      useEffect(() => {
        reloadFormacoes();
      }, [state.mostrar_outras_regioes, state.page, state.filter, debouncedFilter]);

      const pesquisarFormacoesDisponiveis = async (filtro, pesquisa) => {
        let filtragem = {...filtro}

        for (let key in filtragem)
          if (!filtragem[key] || filtragem[key].length === 0) delete filtragem[key];

        setState({
          page: 0,
          filter: filtragem,
          search: pesquisa
        });
      }

      return <ProviderFiltrosAcontecimento acontecimento={'formacao'} atualizar={pesquisarFormacoesDisponiveis}
                                           filterActive={setFilterActive}
                                           lista_filtros={['regiao', 'nucleo', 'agrupamento', 'estado_acontecimento', 'modulo', 'diretor', 'data_desde', 'data_ate', 'enriquecimento', 'formacao_continua']}>
        <Card>
          <CardHeader color="primary">
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <h4 style={{flex: 1}}>Módulos disponíveis para inscrição{state.mostrar_outras_regioes ? "" : " da Região"}</h4>
              <WidgetsFiltrosAcontecimento/>
            </div>
            {!filterActive && <p>Consulte abaixo os módulos disponíveis para participação.</p>}
          </CardHeader>
          <CaixaFiltrosAcontecimento/>
          <ReactTable
            data={state.data.formacoes_disponiveis}
            placeholder={"De momento não existem módulos disponíveis"}
            minRows={1}
            columns={[
              {
                Header: "Formação",
                Cell: (row) => {
                  return <span><StateCircle state={row.original.estado}/> #{general.pad(row.original.id, 5)} - {row.original.modulo}</span>
                }
              },
              {
                Header: "Créditos",
                accessor: "creditos",
                maxWidth: 120
              },
              {
                Header: "Início da formação",
                accessor: "data_inicio",
                Cell: general.Renderers.dateRenderer
              },
              {
                Header: "Local",
                accessor: "regiao",
                width: 250,
                Cell: (row) => row.original.nucleo ? row.original.nucleo + ' / ' + row.original.regiao : row.original.regiao
              },
              {
                Header: "Preço",
                accessor: "preco_inscricao",
                Cell: (row) => row.value.toFixed(2).replace(".", ",") + "€",
                maxWidth: 150
              },
              {
                Header: "",
                width: 80,
                sortable: false,
                Cell: (row) => <Button
                  justIcon
                  round
                  simple
                  style={{margin: 0}}
                  color="info"
                  className="edit"
                  onClick={() => {
                    window.App.openModal(<SweetAlert
                      showClose
                      style={{width: 1200, padding: 40, backgroundColor: "#EEEEEE"}}
                      onConfirm={() => window.App.hideModal()}
                      onCancel={() => window.App.hideModal()}
                      confirmBtnText="Fechar"
                      confirmBtnCssClass={
                        classes.button + " " + classes.primary + " " + classes.buttonConfirm
                      }>
                      <PaginaFormacao id_formacao={row.original.id} visualizacao/>
                    </SweetAlert>);
                  }}><FontAwesomeIcon icon={faSearchPlus}/></Button>
              }
            ]}
            defaultPageSize={state.pageSize}
            showPaginationBottom={true}
            sortable={false}
            className="-striped -highlight"
            pages={state.data?.paginacao?.paginas}
            manual
            onFetchData={(state) => {
              setState({page: state.page, pageSize: state.pageSize});
            }}
          />
          <CardBody style={{textAlign: "right"}}>
            <Button
              className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
              onClick={() => setState({mostrar_outras_regioes: !state.mostrar_outras_regioes})}
              color="success">
              <FontAwesomeIcon icon={state.mostrar_outras_regioes ? faEyeSlash : faEye}/> {state.mostrar_outras_regioes ? "Ocultar" : "Mostrar"} Outras Regiões
            </Button>
          </CardBody>
        </Card></ProviderFiltrosAcontecimento>
    };
    return <C/>
  }, []);

  const CardFormando = useMemo(() => {
    let C = () => {
      if (!general.userHasType("formando") && !general.userHasType("dirigente")) return null;

      const [state, setState] = useReducer(
        (state, newState) => ({...state, ...newState}),
        {
          filter: {},
          search: "",
          data: {formacoes_formando: []},
          page: 0,
          pageSize: 8
        });
      const debouncedFilter = useDebounce(state.search, 200);
      const [filterActive, setFilterActive] = useState(false);

      const reloadFormacoes = () => {
        connection.get("formacao/listagem_inscrito", {
          filtro: state.search,
          filtragem: state.filter,
          numero_resultados: state.pageSize,
          pagina: state.page
        }).then(({formacoes, paginacao}) => {
          setState({
            data: {
              paginacao,
              formacoes_formando: formacoes.sort((a, b) => {
                return a.estado_participacao.acao ? -1 : 0
              })
            }
          });
        });
      }

      const openFeedbackModal = (id, descricao, curso, modalidade) => {
        setModal(<SweetAlert
          style={{
            width: 750, padding: 40
          }}
          title="Feedback do Módulo"
          showCancel={false}
          showConfirm={false}
          onConfirm={() => {
          }}
          onCancel={() => setModal(null)}
          showClose
        >
          <p style={{textAlign: "center"}}><strong>{descricao}{!!curso && <> (curso: {curso})</>}</strong></p>
          <PreencherFeedback formacaoId={id} modalidade={modalidade} onFeedbackGiven={() => {
            reloadFormacoes();
            setModal(null);
          }}/>
        </SweetAlert>);
      }

      useEffect(() => {
        reloadFormacoes();
      }, [state.page, state.filter, debouncedFilter]);

      const pesquisarFormacoesInscrito = async (filtro, pesquisa) => {
        let filtragem = {...filtro}

        for (let key in filtragem)
          if (!filtragem[key] || filtragem[key].length === 0) delete filtragem[key];

        setState({
          page: 0,
          filter: filtragem,
          search: pesquisa
        });
      }

      return <ProviderFiltrosAcontecimento acontecimento={'formacao'} atualizar={pesquisarFormacoesInscrito}
                                           filterActive={setFilterActive}
                                           lista_filtros={['regiao', 'nucleo', 'agrupamento', 'estado_acontecimento', 'modulo', 'diretor', 'data_desde', 'data_ate', 'enriquecimento', 'formacao_continua']}>
        <Card>
          <CardHeader color="primary">
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <h4 style={{flex: 1}}>Módulos Ativos</h4>
              <WidgetsFiltrosAcontecimento/>
            </div>
            {!filterActive && <p>Consulte abaixo os módulos em que está inscrito.</p>}
          </CardHeader>
          <CaixaFiltrosAcontecimento/>
          <ReactTable
            data={state.data.formacoes_formando.map((formacao) => {
              let estado_accao = formacao.estado_participacao.action || [];
              formacao.estado_class = props.classes["formandoEstado" + formacao.estado_participacao.tipo];
              formacao.estado = formacao.estado_participacao.designacao;

              formacao.actions = [];
              if (estado_accao.includes("dar_feedback")) {
                formacao.actions.push((
                  <Button
                    round
                    size="sm"
                    onClick={(e) => {
                      openFeedbackModal(formacao.id, formacao.designacao, formacao.curso, formacao.modalidade);
                      e.stopPropagation()
                    }}
                    color="info"
                    className="edit">
                    Dar Feedback
                  </Button>));
              }
              return formacao;
            })}
            minRows={1}
            columns={[
              {
                Header: "Módulo",
                Cell: (row) => {
                  return <a className={"clickable"} onClick={() => window.open("/formacao/" + row.original.id)}>
                    #{general.pad(row.original.id, 5)} - {row.original.designacao}
                  </a>;
                }
              }, {
                Header: "Estado",
                Cell: (row) => {
                  return <StateCircle state={row.original.estado_participacao} detailed/>
                }
              },
              {
                Header: "Data",
                accessor: "data_inicio",
                Cell: general.Renderers.dateRenderer
              },
              {
                Header: "Local",
                accessor: "regiao",
                width: 250,
                Cell: (row) => row.original.nucleo ? row.original.nucleo + ' / ' + row.original.regiao : row.original.regiao
              },
              {
                Header: "",
                accessor: "actions",
                width: 140,
                sortable: false
              }
            ]}
            defaultPageSize={state.pageSize}
            showPaginationBottom={true}
            sortable={false}
            className="-striped -highlight"
            pages={state.data?.paginacao?.paginas}
            manual
            onFetchData={(state) => {
              setState({page: state.page, pageSize: state.pageSize});
            }}
          />
        </Card></ProviderFiltrosAcontecimento>
    };
    return <C/>
  }, []);

  const adicionarFormacao = async (callback) => {
    let modulo = null;
    let acontecimento_teste = false;

    let modulos = await connection.get("modulo/listagem?isolados=1");

    let Content = () => {
      const [modelo_modulo_state, setModeloModulo] = useState(null);
      const [moduloTeste, setModuloTeste] = useState(!!acontecimento_teste);

      return <form autoComplete="off" className={classes.addForm}>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="modelo_area" className={classes.selectLabel}>
            Módulo
          </InputLabel>
          <Select
            MenuProps={{className: classes.selectMenu}}
            classes={{select: classes.select}}
            value={modelo_modulo_state}
            onChange={(event) => {
              modulo = event.target.value;
              setModeloModulo(event.target.value);
            }}
            inputProps={{
              name: "formacao_modulo",
              id: "formacao_modulo"
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>{"Escolha o módulo"}</MenuItem>
            {modulos.map((modulo) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={modulo.id}>{modulo.codigo} | {modulo.designacao}</MenuItem>;
            })}
          </Select>
          <FormControl fullWidth className={classes.selectFormControl}>
            <InputLabel htmlFor="modo_teste" className={classes.selectLabel}>
              Módulo em modo teste
            </InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              value={moduloTeste}
              onChange={(event) => {
                acontecimento_teste = event.target.value;
                setModuloTeste(event.target.value);
              }}
              inputProps={{
                name: "modo_teste",
                id: "modo_teste"
              }}
            >
              <MenuItem disabled classes={{root: classes.selectMenuItem}}>Selecione se é um módulo em modo de teste</MenuItem>
              <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={false}>Não</MenuItem>
              <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={true}>Sim. Apenas para teste. Não será visível pelos outros utilizadores.</MenuItem>
            </Select>
          </FormControl>
        </FormControl>
      </form>;
    };

    window.App.openModal(<SweetAlert
      style={{width: 520}}
      title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={classes.modalCardTitle}>Criar novo módulo</span>
      </div>)}
      onConfirm={() => {
        connection.post("formacao/nova", {modulo: modulo, acontecimento_teste: acontecimento_teste}, (data) => {
          window.App.hideModal();
          callback && callback(data.id);
        });
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnText="Criar"
      showCancel
      cancelBtnText="Cancelar"
      confirmBtnCssClass={classes.button + " " + classes.primary + " " + classes.buttonConfirm}
      cancelBtnCssClass={classes.button}
    >
      <p style={{margin: "0 10px"}}>Escolha o módulo que pretende dinamizar</p>
      <Content/>
    </SweetAlert>);
  }

  const {classes} = props;

  return (<div>
    {modal}
    <GridContainer>
      <GridItem xs={12}>
        {CardDisponiveis}
      </GridItem>
      <GridItem xs={12}>
        {CardFormando}
      </GridItem>
      <GridItem xs={12}>
        {CardFormador}
      </GridItem>
      <GridItem xs={12}>
        {CardRegiao}
      </GridItem>
    </GridContainer>
  </div>);
}

export default withStyles(formacoesStyle)(FormacoesUtilizador);
